export default {
  name: "ViewSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M31.1 14.33C29.22 11.82 23.98 6 16 6 8.02 6 2.78 11.82.9 14.33a2.64 2.64 0 0 0 0 3.2c1.88 2.5 7.12 8.33 15.1 8.33s13.22-5.82 15.1-8.33c.72-.96.72-2.25 0-3.2zM16 19.85a4 4 0 1 1 0-8 4 4 0 0 1 0 8z",
  },
}
